import { render, staticRenderFns } from "./collegeUserInfo.vue?vue&type=template&id=f27badac&"
import script from "./collegeUserInfo.vue?vue&type=script&lang=js&"
export * from "./collegeUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports